import React, { useState, useContext, useEffect } from "react";
import { motion } from "framer-motion";
import Logo2 from "../assets/img/Logo2.png";
import { cn } from "../../src/utils/utils";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../src/context/AuthContext";
import axios from "../axios/AxiosInstance";
import { message, Popconfirm } from "antd";

import {
  Home,
  Briefcase,
  ShoppingCart,
  Users,
  ClipboardList,
  UserCheck,
  FileText,
  Library,
  Repeat,
  UserCircle,
  LogOutIcon,
  HelpCircle,
  Building,
  logout,
  Bell,
  WatchIcon,
  Clock1,
  Calendar,
} from "lucide-react";

export default function Sidebar({ path }) {
  const [showAgencySwitch, setShowAgencySwitch] = useState(false); // Gère l'affichage de la modale
  const [selectedAgency, setSelectedAgency] = useState(null);
  const { setIsLoggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  const [agencyName, setAgencyName] = useState("");

  const isActive = (chemin) => {
    return chemin === path;
  };

  useEffect(() => {
    const agencyName = localStorage.getItem("agencyName");
    setAgencyName(agencyName);
  }, []);

  const navItems = [
    {
      href: "/dashboard",
      icon: Home,
      label: "Tableau de bord",
    },
    //{ href: "/annonces", icon: Bell, label: "Annonces" },
    { href: "/commandes", icon: ShoppingCart, label: "Commande" },
    { href: "/devis", icon: FileText, label: "Devis" },
    { href: "/planning", icon: ClipboardList, label: "Planning" },
   // { href: "/candidat", icon: UserCheck, label: "Candidat" },
    { href: "/contrat", icon: Briefcase, label: "Contrat" },
    { href: "/prolongations", icon: Calendar, label: "Prolongation" },
    { href: "/relevesdheures", icon: Clock1, label: "Relevés d'heures" },
    { href: "/facture", icon: FileText, label: "Facture" },
    { href: "/documents", icon: Library, label: "Document" },
    { href: "/utilisateur", icon: Users, label: "Utilisateur" },
    { href: "/aide", icon: HelpCircle, label: "Aide en ligne" },
    { href: "/compte", icon: UserCircle, label: "Mon compte" },
  ];

  // Fonction pour ouvrir la modale
  const handleSwitchAgencyClick = () => {
    setShowAgencySwitch(true); // Affiche la modale
  };

  const logout = () => {
    setIsLoggedIn(false);
    localStorage.removeItem("accessToken");
    localStorage.removeItem("isLogged");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userEmail");
    localStorage.removeItem("userRole");
    navigate("/");
  };

  // Fonction pour fermer la modale
  const closeAgencyModal = () => {
    setShowAgencySwitch(false); // Cache la modale
  };

  // Fonction pour changer d'agence
  const switchAgency = (agencyName, agencyId) => {
    console.log(agencyId);
    axios
      .post("agency/switch", { agency: agencyId })
      .then((res) => {
        console.log(res);
        setAgencyName(agencyName);
        navigate("dashboard");
        setShowAgencySwitch(false);
      })
      .catch((e) => {
        console.log(e);
        if (e.response.data.statusCode === 403) {
          message.error("Vous n'etes pas autorisé à changer d'agence !");
        }
      })
      .finally(() => {
        console.log("kkkkk");
      });
  };

  return (
    <aside className="fixed top-0 h-screen scrollbar-none overflow-y-scroll left-0 min-w-[300px] max-w-[300px] bg-gray-900 flex flex-col">
      {/* Logo et nom de l'agence */}
      <div className="flex flex-col items-center py-8 bg-gradient-to-r from-gray-800 to-gray-950 text-white">
        <img src={Logo2} className="w-20 h-20 object-contain rounded-full" />
        <h2 className="text-2xl font-bold tracking-tight">J'M INTERIM</h2>
      </div>

      {/* Menu items */}
      <nav className="flex-1 overflow-y-auto py-8  px-4 scrollbar-none">
        {/* PRINCIPAL */}
        <div className="mb-6 px-3">
          <h3 className="text-xs uppercase text-gray-500 font-medium tracking-widest">
            Principal
          </h3>
        </div>
        <ul className="space-y-2 mb-8">
          {navItems.map((item, index) => {
            const Icon = item.icon;

            return (
              <li key={index}>
                <Link
                  to={item.href}
                  className={cn(
                    "group w-full flex items-center px-4 py-3 text-sm rounded-lg transition-all duration-300 ease-in-out",
                    isActive(item.href)
                      ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white font-medium shadow-md"
                      : "text-gray-300 hover:bg-gray-800/70 hover:text-white",
                  )}
                >
                  <span
                    className={cn(
                      "mr-3.5 flex-shrink-0 transition-transform duration-300",
                      isActive(item.href)
                        ? "text-white scale-110"
                        : "text-gray-400 group-hover:text-gray-200 group-hover:scale-110",
                    )}
                  >
                    <Icon className="w-5 h-5" />
                  </span>
                  <span className="font-medium">{item.label}</span>
                  {isActive(item.href) && (
                    <span className="ml-auto bg-white/20 text-xs py-0.5 px-2 rounded-full">
                      Actif
                    </span>
                  )}
                </Link>
              </li>
            );
          })}

          <Popconfirm
            title="Êtes-vous sûr de vouloir vous déconnecter ?"
            onConfirm={logout}
            okText="Oui"
            cancelText="Non"
            placement="topRight"
          >
            <button className="w-full flex items-center px-4 py-3 text-sm text-gray-300 hover:bg-gray-800/70 hover:text-white rounded-lg">
              <LogOutIcon className="w-5 h-5 mr-3" />
              Déconnexion
            </button>
          </Popconfirm>
        </ul>
      </nav>

      {/* Footer */}
      <div className="py-6 px-6 border-t border-gray-700/50">
        <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-600/30 to-transparent mb-4"></div>
      </div>
    </aside>
  );
}
